module.exports = __webpack_public_path__ + "img/but_multiple_on.37c90c8d.png";